export default __webpack_public_path__ + "static/media/dibLogo.41c10b79.png";